import { IDs } from '../../../helpers/IDs';

export function findGTZOrt(data: any, lat: number, lon: number, valid?: boolean): any {
    const orte: Array<any> = data[IDs.ENT_GTZ_ORTE] || [];
    console.log('Wetter-Orte: ', orte);
    let minDist = 9999999;
    let ort_found: any = undefined;

    orte.forEach((ort: any) => {
        if (valid && (+ort.ungueltig || 0) === 1) {
            return;
        }
        const lat_ort = ort.latitude;
        const lon_ort = ort.longitude;
        const lat_diff = Math.abs(lat - lat_ort);
        const lon_diff = Math.abs(lon - lon_ort);
        const dist = Math.sqrt(lat_diff * lat_diff + lon_diff * lon_diff); // Pythagoras

        if (!ort_found || dist < minDist) {
            ort_found = ort;
            minDist = dist;
        }
    });

    return ort_found;
}
